import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class AiFeedbackStore extends LocalModel {
    constructor() {
        super('aiFeedback', {
            namePlural: 'aiFeedbacks',
            namePluralReal: 'aifeedback',
            sort: '-flaggedDate',
            limit: 50,
            api: {
                search: { url: '/api/aifeedback/', params: { limit: 50 } },
                load: { url: '/api/aifeedback/', params: {} },
                save: { url: '/api/aifeedback/', params: {} },
                delete: { url: '/api/aifeedback/', params: {} },
            },
        });
    }

    @observable aiFeedbacks = [];

    @observable aiFeedback = {};

    @observable stats = { byCategory: {}, byStatus: {}, total: 0 };

    @action
    async loadForTicket(ticketId) {
        if (!ticketId) {
            this.updateKeyValue('aiFeedbacks', []);
            return;
        }
        try {
            const response = await util.fetchApi('/api/aifeedback/', { method: 'GET' }, {
                ticket: ticketId,
                status: 'all',
                limit: 200,
            });
            if (response?.status === 200) {
                this.updateKeyValue('aiFeedbacks', response.data || []);
            }
        } catch (err) {
            console.error('aiFeedback loadForTicket failed', err);
        }
    }

    getForMessage(messageUuidv4) {
        return (this.aiFeedbacks || []).find(f => f.messageUuidv4 === messageUuidv4 && !f.offline);
    }

    @action
    async submitFeedback({ ticketUuidv4, messageUuidv4, category, comment }) {
        const response = await util.fetchApi('/api/aifeedback/', { method: 'POST' }, {
            ticketUuidv4, messageUuidv4, category, comment,
        });
        if (response?.status === 200 && response.data) {
            const next = (this.aiFeedbacks || []).filter(
                f => !(f.messageUuidv4 === messageUuidv4 && f.ticketUuidv4 === ticketUuidv4),
            );
            next.unshift(response.data);
            this.updateKeyValue('aiFeedbacks', next);
            return response.data;
        }
        return null;
    }

    @action
    async updateFeedback(uuidv4, patch) {
        const response = await util.fetchApi(`/api/aifeedback/${uuidv4}`, { method: 'PATCH' }, patch);
        if (response?.status === 200 && response.data) {
            const next = (this.aiFeedbacks || []).map(f => (f.uuidv4 === uuidv4 ? response.data : f));
            this.updateKeyValue('aiFeedbacks', next);
            return response.data;
        }
        return null;
    }

    @action
    async deleteFeedback(uuidv4) {
        const response = await util.fetchApi(`/api/aifeedback/${uuidv4}`, { method: 'DELETE' });
        if (response?.status === 200) {
            const next = (this.aiFeedbacks || []).filter(f => f.uuidv4 !== uuidv4);
            this.updateKeyValue('aiFeedbacks', next);
            return true;
        }
        return false;
    }

    @action
    async loadList(filters = {}) {
        const response = await util.fetchApi('/api/aifeedback/', { method: 'GET' }, filters);
        if (response?.status === 200) {
            this.updateKeyValue('aiFeedbacks', response.data || []);
            return { rows: response.data || [], meta: response.meta };
        }
        return { rows: [], meta: {} };
    }

    @action
    async loadStats(customerOverride) {
        const params = customerOverride ? { customer: customerOverride } : {};
        const response = await util.fetchApi('/api/aifeedback/stats', { method: 'GET' }, params);
        if (response?.status === 200) {
            this.updateKeyValue('stats', response.data);
            return response.data;
        }
        return null;
    }
}

const store = new AiFeedbackStore();
export default store;
